<div class="modal-main create-user" [formGroup]="formGroup">
  <ng-container *ngIf="stepper === 1">
    <app-lock-info
      formGroupName="lockInfo"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
    >
    </app-lock-info>
  </ng-container>

  <ng-container *ngIf="stepper === 2">
    <app-lock-name
      formGroupName="lockNameSet"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
      (submitToParent)="submitToParent()"
    >
    </app-lock-name>
  </ng-container>

  <ng-container *ngIf="stepper >= 2">
    <app-successful-create-lock
      [class.d-block]="stepper === 3"
      class="d-none"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
    >
    </app-successful-create-lock>
  </ng-container>
</div>
